import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetVehicles = () =>
  useMutation({
    mutationFn: (data) => client(`resources/vehicles`, { data }),
  });
export const useAddVehicles = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/vehicles/add`, {
        data,
        successMessage: "Vehicle has been added successfully",
      }),
  });

export const useGetVehicleDetails = () =>
  useMutation({
    mutationFn: (data) => client(`resources/vehicles/${data}`),
  });

export const useUpdateVehicles = () =>
  useMutation({
    mutationFn: (data) =>
      client(`resources/vehicles/edit`, {
        data,
        successMessage: "Vehicle has been updated successfully",
      }),
  });
